<template>
    <div class="custom-activity">
        <div v-if="courseList.length > 0" class="text-left flex-display ai-center change-display">
          <p class="mg-less">เลือกหลักสูตร</p>
          <el-dropdown class="mg-l-4" trigger="click">
            <span class="el-dropdown-link course-box">
              <span class="message-over clamp1">{{
                getCourseLabel(course)
              }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="course-box-menu">
              <el-dropdown-item v-for="item in courseList" :key="item._id"
                ><div
                  @click="course = item._id"
                  class="dropdown-text-over"
                  :title="item.name"
                >
                  {{ item.name }}
                </div></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            @click="selectCourse"
            type="primary"
            class="light mg-l-4 btn-show"
            round
            >แสดงผล</el-button
          >
        </div>
        <div v-loading="loading">
            <el-row :gutter="20" class="pd-t-3">
                <el-col
                v-for="item in studentList"
                :key="item.id"
                :span="24"
                :sm="12"
                :md="12"
                :lg="6"
                class="margin-custom"
                >
                <DashboardUserNumber :courseId="courseId" :id="item.id" :label="item.label" :color="item.color" :value="item.value" />
                </el-col>
            </el-row>
            <el-row :gutter="20" class="pd-t-3">
                <el-col :span="24" class="margin-custom">
                <DashboardFeedback :name="getCourseLabel(courseId)" :avg="feedbackAvg"/>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="pd-t-3">
                <el-col :span="24" :md="12" :lg="12" class="margin-custom">
                <DashboardUserTable
                    title="ผู้เรียนที่เข้าระบบล่าสุด"
                    :labels="[{ key: 'learnDate', type: 'date', name: 'เข้าระบบล่าสุดเมื่อ' }]"
                    :dataTable="studentRecent.slice(0,5)"
                    @openDialog="dialogRecentVisible=true"
                />
                </el-col>
                <el-col :span="24" :md="12" :lg="12" class="margin-custom">
                <DashboardUserTable
                    title="ผู้เรียนจบหลักสูตรล่าสุด"
                    :labels="[
                    { key: 'successDate', type: 'date', name: 'จบหลักสูตรเมื่อ' },
                ]"
                    :dataTable="studentGraduate.slice(0,5)"
                    @openDialog="dialogGraduateVisible=true"
                />
                </el-col>
            </el-row>
        </div>
        <el-dialog title="ผู้เรียนที่เข้าระบบล่าสุด" :visible.sync="dialogRecentVisible">
            <DashboardTable             
                :labels="[{ key: 'learnDate', type: 'date', name: 'เข้าระบบล่าสุดเมื่อ' }]"
                :dataTable="studentRecent">
            </DashboardTable>
        </el-dialog>
        <el-dialog title="ผู้เรียนจบหลักสูตรล่าสุด" :visible.sync="dialogGraduateVisible">
            <DashboardTable             
                :labels="[{ key: 'successDate', type: 'date', name: 'จบหลักสูตรเมื่อ' }]"
                :dataTable="studentGraduate">
            </DashboardTable>
        </el-dialog>
    </div>
</template>

<script>
import DashboardUserNumber from "./DashboardUserNumber";
import DashboardUserTable from "./DashboardUserTable";
import DashboardTable from "./DashboardTable";
import DashboardCourseTotalList from "./DashboardCourseTotalList";
import DashboardFeedback from "./DashboardFeedback";

import { HTTP } from "@/service/axios.js";
import {CancelToken } from "axios";

export default {
  components: {
    DashboardUserNumber,
    DashboardUserTable,
    DashboardTable,
    DashboardCourseTotalList,
    DashboardFeedback
  },
  computed: {
    courseList(){
      return this.$store.state.courseList
    },
    token(){
      return this.$store.state.token
    }
  },
  data() {
    return {
      dialogRecentVisible:false,
      dialogGraduateVisible:false,
      course:'',
      loading:true,
      courseId:'',
      studentList: [
        { id: 1, label: "จำนวนผู้สมัครหลักสูตร", value: 0, color: "#0065B3" },
        { id: 2, label: "จำนวนเข้าร่วมหลักสูตร", value: 0, color: "#00B2FF" },
        { id: 3, label: "จำนวนผู้กำลังเรียน", value: 0, color: "#FFB800" },
        { id: 4, label: "จำนวนผู้จบหลักสูตร", value: 0, color: "#FFE91F" },
      ],
      studentRecent: [],
      studentGraduate: [],
      activeName:'1',
      dashboardCourseList:[],
      source:'',
      feedbackAvg:0
    };
  },
  mounted() {
    this.fetchCourseList()
    this.fetchDashboard()
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      if (this.courseList.length > 0) {
        this.course = this.courseList[0]._id
        this.courseId = this.course
      }
    },
    fetchDashboard() {
      if (this.source) {
          this.source.cancel()
      }

      this.source = CancelToken.source()
      const cancelToken = this.source.token

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`dashboard/${this.courseId}`,{cancelToken})
        .then((res) => {
 
          if (res.data.success) {
            this.studentList[0].value = res.data.obj.register
            this.studentList[1].value = res.data.obj.approved
            this.studentList[2].value = res.data.obj.studying
            this.studentList[3].value = res.data.obj.success

            this.studentRecent = res.data.obj.latestLearn
            this.studentGraduate = res.data.obj.successUser
            this.feedbackAvg = res.data.obj.assessment
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          console.log("fetchDashboard error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
   selectCourse() {
      this.loading = true;
      this.courseId = this.course
      this.fetchDashboard();
    },
    getCourseLabel(course) {
      let filter = this.courseList.filter((filter) => filter._id == course);
      return filter.length > 0 ? filter[0].name : "";
    },
  },
};
</script>
